import { PaletteMode } from "@mui/material";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface ColorModeState {
  mode: PaletteMode;
}

const initState: ColorModeState = {
  mode: "light",
};

export const colorModeSlice = createSlice({
  name: "colorMode",
  initialState: initState,
  reducers: {
    toggleColorMode: (state) => {
      state.mode = state.mode === "light" ? "dark" : "light";
    },
    setColorMode: (state, action: PayloadAction<PaletteMode>) => {
      state.mode = action.payload;
    },
  },
});

export const colorModeAction = colorModeSlice.actions;

export default colorModeSlice.reducer;
